// frame Ye71I @ ui/dogdisk-agent.pen — 域名防墙·域名配置(对齐设计稿 Dm0nG)
// 跳转组:每组 一级 → 二级 → 本站代理 / 自定义域名,互不干扰。
import { useState } from 'react'
import { Network } from 'lucide-react'
import { Button, Spinner } from '@dogdisk/shared'
import { AgentLayout } from '../components/agent-layout'
import { useJumpChains, useCreateJumpChain } from '../_lib/jumpdomain-api'
import { ChainCard } from '../components/domain-guard/chain-card'
import { AddChainDialog } from '../components/domain-guard/add-chain-dialog'

export function AgentDomainGuardDomainsPage() {
  return (
    <AgentLayout topbarTitle="域名防墙 · 域名配置">
      <div className="space-y-6 p-6">
        <DomainGuardDomainsSection />
      </div>
    </AgentLayout>
  )
}

function DomainGuardDomainsSection() {
  const { data, isLoading } = useJumpChains()
  const chains = data?.chains ?? []
  const [showAddChain, setShowAddChain] = useState(false)
  const createChain = useCreateJumpChain()

  return (
    <section data-testid="Ye71I">
      {/* PageHeader CYUPb */}
      <header className="mb-4 flex items-center justify-between">
        <div>
          <h1 className="flex items-center gap-2 text-2xl font-bold text-gray-900">
            <Network className="h-6 w-6 text-blue-600" />
            域名配置
          </h1>
          <p className="mt-1 text-sm text-gray-500">
            跳转组：每组「一级 → 二级 → 本站代理 / 自定义域名」独立维护，互不干扰
          </p>
        </div>
        <Button onClick={() => setShowAddChain(true)} data-testid="Ye71I-add-chain">
          + 添加跳转组
        </Button>
      </header>

      {isLoading ? (
        <Spinner />
      ) : chains.length === 0 ? (
        <p className="rounded-lg border border-dashed border-gray-200 py-10 text-center text-sm text-gray-400">
          尚未配置跳转组;点右上角「添加跳转组」开始
        </p>
      ) : (
        <div className="space-y-4">
          {chains.map((c) => (
            <ChainCard key={c.id} chain={c} />
          ))}
        </div>
      )}

      {showAddChain && (
        <AddChainDialog
          onClose={() => setShowAddChain(false)}
          onSubmit={async (input) => {
            await createChain.mutateAsync(input)
            setShowAddChain(false)
          }}
        />
      )}
    </section>
  )
}
